module.exports = __webpack_public_path__ + "static/media/T1.32ca6442.png";